var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"view-pic"},[(_vm.useSvg)?_c('pic-svg',{attrs:{"asset":_vm.asset}}):_c('pic-img',{attrs:{"src":_vm.src,"title":_vm.title,"hideUntilLoaded":_vm.hideUntilLoaded}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc707e8e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/snippets/Pic.vue
// module id = 389
// module chunks = 0